module.exports = __webpack_public_path__ + "static/media/EV4.e2f8724c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/EV4.jpg
// module id = 186
// module chunks = 0